module.exports = __webpack_public_path__ + "Public/Home/staticmokao/img/part8.c0387f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2022/part8.jpg
// module id = BdFx
// module chunks = 1